import * as React from 'react';
import ZoomInOutlined from './zoom-in-outlined';
import ZoomInFilled from './zoom-in-filled';
import type { IconCombinedProps } from './types';
const ZoomInCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ZoomInFilled ref={ref} {...rest} />;
  }
  return <ZoomInOutlined ref={ref} {...rest} />;
});
export default ZoomInCombined;